import React from 'react';
// import { useTranslation } from 'react-i18next';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Col, Row } from 'antd';
import { AgreementCheckboxLI } from 'components/agreementCheckboxLI';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';

type AgreementCardProp = {
  setIsAgreed: (val: boolean) => void;
};

export const AgreementCard = ({ setIsAgreed }: AgreementCardProp) => {
  // const { t } = useTranslation();

  const onChange = (e: CheckboxChangeEvent) => {
    setIsAgreed(e.target.checked);
  };
  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <BoldLabelFormItem style={{ borderTop: '1px solid #cccccc' }}>
          <AgreementCheckboxLI onChange={onChange} />
        </BoldLabelFormItem>
      </Col>
    </Row>
  );
};
